var _path, _g, _path2, _path3, _path4, _g2, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEmptyResults(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 113,
    viewBox: "0 0 144 113",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1143_4485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 96,
    width: 144,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.0968628 96.0708H143.195V112.434H0.0968628V96.0708Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1143_4485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M143.195 104.253C143.195 99.734 111.161 96.0708 71.6457 96.0708C32.1305 96.0708 0.0967407 99.734 0.0967407 104.253C0.0967407 108.771 32.1305 112.434 71.6457 112.434C111.161 112.434 143.195 108.771 143.195 104.253Z",
    fill: "#F7F7F7"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.6637 83.4906L50.9633 81.3269L60.0388 68.6587L73.1037 75.3973L75.532 82.8993C75.532 82.8993 61.7781 91.5088 51.6637 83.4906Z",
    fill: "#E3E3E3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M87.7512 53.3149L97.0493 57.9628L93.6251 64.6907L84.3271 60.0422L87.7512 53.3149Z",
    fill: "#BBBBBB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_1143_4485",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 13,
    y: 0,
    width: 80,
    height: 79
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5135 0.226074H92.1049V78.6483H13.5135V0.226074Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_1143_4485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.9081 60.436C69.3999 70.9077 54.0827 74.8544 41.4879 70.1208C29.5112 65.8807 20.857 54.1193 20.1151 41.4989C18.9747 27.0541 28.775 12.6449 42.6469 8.38193C45.181 7.5629 47.8146 7.04877 50.4718 6.85526C63.4316 5.72846 76.4643 13.289 82.1528 24.9183C87.9709 36.2348 86.1036 50.7589 77.9081 60.436ZM90.1581 27.2711C83.4278 6.68602 61.2416 -4.54482 40.6164 2.17169C19.992 8.88892 8.73223 31.0136 15.4625 51.598C22.1928 72.1831 44.3604 83.4203 64.9848 76.7031C85.6099 69.9866 96.8876 47.8555 90.1581 27.2711Z",
    fill: "#CFCFCF"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.086 60.565C102.98 63.3006 101.483 66.2418 98.7425 67.1344C96.0016 68.027 93.0546 66.5332 92.1603 63.7976C91.2653 61.062 92.7627 58.1207 95.5036 57.2282C98.2445 56.3356 101.191 57.8294 102.086 60.565Z",
    fill: "#CFCFCF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.47 74.6817L101.397 56.5444C100.205 55.9617 98.765 56.4537 98.1805 57.6426L94.0401 66.0736C93.4556 67.2639 93.9486 68.7007 95.1405 69.284L112.047 77.5551L114.575 71.0699L116.388 76.6711L121.067 78.3513C121.067 78.3513 121.464 76.3947 122.458 82.6485L132.213 87.4206C133.405 88.004 134.845 87.512 135.429 86.3224L139.57 77.8914C140.154 76.7018 139.662 75.2651 138.47 74.6817Z",
    fill: "#BBBBBB"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.0922 24.9405C76.4129 13.3291 63.4002 5.77995 50.4598 6.9046C47.8076 7.09812 45.1783 7.61082 42.6478 8.42914C28.7966 12.6857 19.0113 27.0734 20.1496 41.4954C20.737 51.4852 26.2925 60.9323 34.5267 66.5299L47.1952 49.0388L50.9256 65.1896L60.6372 53.3811L72.4765 60.1475L73.8652 64.4377C75.3111 63.2259 76.6533 61.882 77.8546 60.4039C86.0372 50.7419 87.9017 36.2399 82.0922 24.9405Z",
    fill: "#F7F7F7"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5267 66.5296L36.7847 67.9863L48.3686 54.1199L47.1953 49.0386L34.5267 66.5296Z",
    fill: "#E3E3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9259 65.1894L53.0315 67.0695L63.6388 55.0968L60.6368 53.3809L50.9259 65.1894Z",
    fill: "#E3E3E3"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.7496 87.0072L39.1558 71.2563L39.2223 96.5514L29.8306 93.3646L32.7496 87.0072Z",
    fill: "#F7F7F7"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.8308 93.3643V97.1103L39.2226 98.6276V96.5511L29.8308 93.3643Z",
    fill: "#E3E3E3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M47.8678 86.9072L46.9041 100.378L50.5078 99.6804L47.8678 86.9072Z",
    fill: "#BBBBBB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M85.5339 76.9409L99.3429 90.5425L100.859 87.0664L85.5339 76.9409Z",
    fill: "#BBBBBB"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.9633 81.3265L59.3384 66.4946L72.4033 73.2333L74.8316 80.7345C74.8316 80.7345 61.0777 89.3448 50.9633 81.3265Z",
    fill: "#F7F7F7"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.5993 73.959L6.60614 80.1692L10.6349 85.2784L25.5993 73.959Z",
    fill: "#BBBBBB"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.047 77.555L116.006 78.6482L122.458 82.6484L122.043 77.1687L116.388 76.671L114.575 71.0698L112.047 77.555Z",
    fill: "#CFCFCF"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyResults);
export default __webpack_public_path__ + "static/media/empty-results.d61a7aee219b782223a22c3facfca8be.svg";
export { ForwardRef as ReactComponent };